import UpdateConditionals from './UpdateConditionals';
import UpdateProgressBar from './UpdateProgressBar';
import ToggleNewData from './ToggleNewData';
import RemoveMultiOption from './RemoveMultiOption';

// Remove multi-select options
export default function(parentContainer) {

  // Substring matcher for multi-select typeahead
  let substringMatcher = function(strs) {
    return function findMatches(q, cb) {

      // an array that will be populated with substring matches
      let matches = [];

      // regex used to determine if a string contains the substring `q`
      let substrRegex = new RegExp(q, 'i');

      // iterate through the pool of strings and for any string that
      // contains the substring `q`, add it to the `matches` array
      $.each(strs, function(i, str) {
        if (substrRegex.test(str)) {
          matches.push(str);
        }
      });

      cb(matches);
    };
  };

  if (parentContainer.find('.manual-list-typeahead-multiple').length !== 0) {
    parentContainer.find('.manual-list-typeahead-multiple').typeahead('destroy');
    parentContainer.find('.manual-list-typeahead-multiple').each(function(el){
      let id = $(this).attr('id');
      let listOptions = [];
      let i = 0;
      let optsList = $('#' + id).attr('data-list-options');
      if (typeof optsList === 'undefined') {return;}
      let dataOpts = JSON.parse(optsList);
      while (i < dataOpts.length) {
        listOptions.push(dataOpts[i]);
        i++;
      }

      $('#' + id).typeahead({
        hint: true,
        highlight: true,
        minLength: 0
      },
      {
        name: 'list',
        limit: 554,
        source: substringMatcher(listOptions)
      });

      $('#' + id).bind('typeahead:beforeselect', function(ev, suggestion) {

        // Set vars
        let fg = $(this).closest('.form-group');
        let multiContainer = fg.find('.multi-selected-container');
        let hidden = fg.find('.answer-text');
        let selected = fg.find('.multi-selected-container .selected-opt');
        let selectedExists = multiContainer.find('.selected-opt[data-text=\'' + suggestion + '\']');

        // Update hidden value
        if (selected.length === 0) {
          hidden.val(suggestion).trigger('change');
        } else {
          let updatedVal = suggestion;
          $.each(selected, function(i,k) {
            updatedVal += '|' + $(k).attr('data-text');
          });
          hidden.val(updatedVal).trigger('change');
        }

        // Append value to list of selected options
        if (selectedExists.length === 0) {
          let text = "<div class=\'selected-opt w-100 p-2 d-flex align-items-center mr-2\' data-text=\'" + suggestion + "\' >"
          text += "<div class=\'mr-2\'>" + suggestion + "</div>";
          text += "<div class=\'ml-auto\'>";
          text += "<a class=\'clickable remove-multi-select\' data-text=\'" + suggestion + "\' data-toggle=\'tooltip\' data-title=\'Remove selected option\'>";
          text += "<svg width='14' height='16' viewBox='0 0 14 16' fill='none' xmlns='http://www.w3.org/2000/svg'>"
          text += "<g id='Icon Right'>";
          text += "<path id='Vector' d='M4.2 3.79989V2.39989C4.2 1.88442 4.61787 1.46655 5.13333 1.46655H8.86667C9.38213 1.46655 9.8 1.88442 9.8 2.39989V3.79989M0.875 ";
          text += "4.26655H13.125M2.275 4.26655V13.5999C2.275 14.1154 2.69287 14.5332 3.20833 14.5332H10.7917C11.3071 14.5332 11.725 14.1154 11.725 13.5999V4.26655M7 ";
          text += "7.12489V11.8499M5.075 7.12489V11.8499M8.925 7.12489V11.8499' stroke='#DA3547' stroke-linecap='round' stroke-linejoin='round'></path>";
          text += "</g></svg>";
          text += "</a></div></div>"
          multiContainer.append(text)

          // Indicate that container has new data for saving
          ToggleNewData(hidden);

          // Re-set remove function
          RemoveMultiOption();

        }

        $('#' + id).typeahead("destroy");
        $('#' + id).typeahead({
          hint: true,
          highlight: true,
          minLength: 0
        },
        {
          name: 'list',
          limit: 554,
          source: substringMatcher(listOptions)
        });

      });

    });

    // Save if conditions
    parentContainer.find('.manual-list-typeahead-multiple').bind('typeahead:select typeahead:autocomplete', function(ev, suggestion) {
      let el = $(this);
      let ig = el.closest('.input-group');
      let answer = ig.find('.answer-text').val();
      ToggleNewData(el);
      el.closest('.question-row').removeClass('incomplete');
      let valsChanged = $('.survey-card-body[data-val-changed=true]');
      let hasDependencies = ig.attr('data-has-dependencies');
      if ((valsChanged.length > 0) && (hasDependencies === "true")) {
        UpdateConditionals(ig, answer);
      }
      UpdateProgressBar(ig.find('.answer-text')[0]);
    });

  }


}